import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import {checkAuthCrmUser, isLoginRedirectScheduled, LOGIN_PATH} from './store/settings';
import TektaStorybook from 'tekta-storybook';
import VueMask from 'v-mask';
import Vuelidate from 'vuelidate';
import addCustomScripts from '@/helpers/custom';
import {PROFILE_FILLING_PATH} from './helpers/authRedirect';

Vue.use(TektaStorybook);
Vue.use(Vuelidate);
Vue.use(VueMask);

if (window.location.hash === '#callback') {
    sessionStorage.setItem('pendingCallback', '1');
}

router.beforeEach(async (to, from, next) => {
    // Дефолтное имя сайта
    const siteName = 'Tekta ЛК брокера';

    document.title = to.meta.title || siteName;

    // Если требуется авторизация, проверяем авторизован ли пользователь
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let allowed = false;

        try {
            allowed = await checkAuthCrmUser();
        } catch (error) {
            allowed = false;
        }

        if (allowed !== true) {
            if (isLoginRedirectScheduled() || window.location.pathname === LOGIN_PATH) {
                next(false);
                return;
            }

            next({
                path : LOGIN_PATH,
                query: {
                    ...to.query,
                    redirect: to.query.redirect || to.path
                }
            });
            return;
        }

        if (to.meta.pdf) {
            next();
            return;
        }

        if (!store.getters.GET_IS_AUTHENTICATED) {
            next({
                path : '/login',
                query: {
                    ...to.query,
                    redirect: to.query.redirect || to.path
                }
            });
            return;
        }

        try {
            if (!store.getters.GET_IS_USER_DATA_LOADED) {
                await store.dispatch('getUserData');
            }
        } catch (error) {
            if (!store.getters.GET_IS_AUTHENTICATED) {
                next({
                    path : '/login',
                    query: {
                        ...to.query,
                        redirect: to.query.redirect || to.path
                    }
                });
                return;
            }

            if (!to.meta.profileFilling) {
                next({
                    path : PROFILE_FILLING_PATH,
                    query: {
                        ...to.query,
                        redirect: to.query.redirect || to.path
                    }
                });
                return;
            }

            next();
            return;
        }

        const isComplete = store.getters.GET_IS_PROFILE_COMPLETE;
        const isFillingPage = Boolean(to.meta.profileFilling);

        if (!isComplete && !isFillingPage) {
            next({
                path : PROFILE_FILLING_PATH,
                query: {
                    ...to.query,
                    redirect: to.query.redirect || to.path
                }
            });
            return;
        }

        if (isComplete && isFillingPage) {
            const redirectPath = to.query.redirect;

            if (redirectPath && redirectPath !== PROFILE_FILLING_PATH) {
                next(redirectPath);
                return;
            }

            next('/appointments');
            return;
        }

        next();
    } else {
        next();
    }
});

addCustomScripts();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
